import styled from 'styled-components';

import GoogleCloudFilePreview from 'components/GoogleCloudFilePreview';
import TextInput from 'components/TextInputNew';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 10px;
  position: relative;
  margin: 10px;
  width: 140px;
`;

export const PreviewWrap = styled.div`
  position: relative;
`;

export const Preview = styled(GoogleCloudFilePreview)`
  cursor: pointer;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: var(--color-green65);
  opacity: 0.45;
  border-radius: var(--border-radius8);
  pointer-events: none;
`;

export const Name = styled.p`
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-grey6A);
  font-size: var(--font-size13);
`;

export const Input = styled(TextInput)`
  height: 20px;
  font-size: var(--font-size13);
`;

export const ButtonWrap = styled.div`
  display: flex;
`;

export const SmallBtn = styled.button`
  display: block;
  width: 22px;
  height: 22px;
  background: var(--color-greyEC);
  border: 1px solid var(--color-greyF8);
  border-radius: 50%;
  margin-right: 5px;
  outline: none;
  cursor: pointer;
  &:hover {
    background: var(--color-greyEC);
    border: 1px solid var(--color-greyEC);
  }
  &:focus {
    box-shadow: var(--shadow-focus);
  }
  &:active {
    background: var(--color-white);
    border: 1px solid var(--color-grey6A);
  }
  &:disabled {
    border: 1px solid var(--color-white);
    cursor: not-allowed;
  }
`;

export const DeleteBtn = styled(SmallBtn)`
  margin-left: auto;
  margin-right: 0;
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
`;
